import { connect } from 'react-redux';
import LeggerRekap from '../../../views/Kurikulum/Raport/LeggerRekap.view.js';
import { getStudent } from '../../../states/thunks/student.thunk';


function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
  };
}
export default connect(null, mapDispatchToProps)(LeggerRekap);
